import { createStyles, makeStyles, Theme } from "@material-ui/core";
import { COLORS } from "../../../core/consts/redesign/commonRedesign";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    paper: {
      outline: 'none',
      position: "absolute",
      width: "800px",
      height: "fit-content",
      top: "50%",
      left: "calc(50% + 60px)",
      transform: "translate(-50%, -50%)",
      backgroundColor: COLORS.white,
      border: "none",
      padding: "48px",
      borderRadius: "8px",
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: '24px',
      maxHeight: `calc(100% - 65px)`,
      overflowY: "auto",
      [theme.breakpoints.down(1024)]: {
        width: "100%",
        height: "100%",
        left: 0,
        top: 0,
        transform: "translateX(0%)",
        margin: 0,
        borderRadius: 0,
        padding: "16px",
      }
    },
    closeButton: {
      width: '24px',
      height: '24px'
    },
    box: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
      width: "100%",
    },
    title: {
      fontSize: '41px',
      lineHeight: '45px',
      fontWeight: 600,
      color: COLORS.black,
      margin: 0,
      padding: 0,
      [theme.breakpoints.down(1024)]: {
        fontSize: '21px',
        lineHeight: '25px',
      }
    },
    text: {
      fontSize: '16px',
      lineHeight: '21px',
      fontWeight: 500,
      color: COLORS.black,
    },
    checkBoxesBox: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "flex-start",
      width: "100%",
      gap: '24px',
    },
    checkRowBox: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "flex-start",
      alignItems: "center",
      width: "100%",
      flexWrap: 'wrap',
      gap: '24px',
      columnGap: "24px",
    },
    checkboxes: {
      display: "flex",
      flexDirection: "row",
      gap: '8px',
      alignItems: "center",
      justifyContent: "flex-start",
    },
    checkbox: {
      width: '24px',
      height: '24px'
    },
    checkboxText: {
      fontFamily: 'Gilroy',
      fontStyle: 'normal',
      fontSize: '16px',
      fontWeight: 500,
      lineHeight: '21px',
      color: COLORS.black
    },
    swithersBox: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "baseline",
      width: "100%",
      flexWrap: 'wrap',
      gap: '24px',
      columnGap: "24px",
      [theme.breakpoints.down(1024)]: {
        flexDirection: "column",
        gap: '16px'
      }
    },
    divider: {
      minHeight: '2px',
      width: '100%',
      background: COLORS.light_gray_stroke,
    },
    templatesBox: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      justifyContent: 'flex-start',
      gap: '16px'
    },
    templateTitle: {
      fontSize: '21px',
      lineHeight: '28px',
      fontWeight: 500,
      color: COLORS.black,
    },
    templateSubtitle: {
      fontSize: '16px',
      lineHeight: '21px',
      fontWeight: 500,
      color: COLORS.gray2,
    }
  })
);
